var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 6.875V0.125H1.25V5.75H7.4375V0.125H13.25C13.9719 0.125 14.5898 0.382063 15.1038 0.896188C15.6179 1.41019 15.875 2.02812 15.875 2.75V6.875H0.125ZM8.5625 5.75H14.75V2.75C14.75 2.3375 14.6031 1.98438 14.3094 1.69063C14.0156 1.39688 13.6625 1.25 13.25 1.25H8.5625V5.75ZM4.25094 4.66831C4.78394 4.66831 5.23675 4.48169 5.60938 4.10844C5.982 3.73531 6.16831 3.28219 6.16831 2.74906C6.16831 2.21606 5.98169 1.76325 5.60844 1.39062C5.23531 1.018 4.78219 0.831688 4.24906 0.831688C3.71606 0.831688 3.26325 1.01831 2.89062 1.39156C2.518 1.76469 2.33169 2.21781 2.33169 2.75094C2.33169 3.28394 2.51831 3.73675 2.89156 4.10938C3.26469 4.482 3.71781 4.66831 4.25094 4.66831ZM4.25 3.54331C4.02787 3.54331 3.84013 3.46663 3.68675 3.31325C3.53338 3.15988 3.45669 2.97213 3.45669 2.75C3.45669 2.52787 3.53338 2.34013 3.68675 2.18675C3.84013 2.03338 4.02787 1.95669 4.25 1.95669C4.47213 1.95669 4.65988 2.03338 4.81325 2.18675C4.96663 2.34013 5.04331 2.52787 5.04331 2.75C5.04331 2.97213 4.96663 3.15988 4.81325 3.31325C4.65988 3.46663 4.47213 3.54331 4.25 3.54331Z",
    fill: "#EDEEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIconWhite);
export default __webpack_public_path__ + "static/media/bed-icon-white.6803a4259ddc4e08e4a5647f8be8ee65.svg";
export { ForwardRef as ReactComponent };